import { useEffect } from 'react';

import { usePdfHighlighterContext } from '~/components/Shared/EcPdfViewerHighlighter/components/PdfHighlighterContext';
import { Nullable } from '~/types/Nullable';
import { scrollToHighlight } from '~/utils/highlights';

import { PDF_HIGHLIGHT_SCROLL_TOP_OFFSET } from './constants';
import { PdfHighlight } from './types';

export const useScrollToHighlight = ({
  activeHighlightId,
  pdfHighlights,
  deps = [],
}: {
  activeHighlightId?: string;
  pdfHighlights: Nullable<PdfHighlight>[];
  deps?: any[];
}) => {
  const { viewer } = usePdfHighlighterContext();

  useEffect(() => {
    const activePdfHighlight = pdfHighlights.find(
      (pdfHighlight) => pdfHighlight?.id === activeHighlightId,
    );

    if (activePdfHighlight) {
      scrollToHighlight(
        viewer,
        activePdfHighlight.position,
        PDF_HIGHLIGHT_SCROLL_TOP_OFFSET,
      );
    }
  }, [activeHighlightId, ...deps]);
};
